export default __webpack_public_path__ + "static/media/CNo.37-3.d461c6f0.jpg";